import {useRouter} from "next/router";
import {useState} from "react";
import Checklist from "./common/Checklist";
import RadioGroupList from "./common/RadioGroupList";
import MobileFilterMenu from "./MobileFilterMenu/MobileFilterMenu";
import {Filter, FilterAnyLabels} from "../data/Filter/Filter.config";
import {LivingAreaItems, PlotSizeItems, VerkaufAusstattungItems, VerkaufLageItems} from "../data/Filter/VerkaufFilter.config";
import {SchlafzimmerItems, VermietungCategories} from "../data/Filter/VermietungFilter.config";
import {enforceArray, handleChecklistFilterChange, handleDropdownSelect, handleSearchChange, replaceRouterQueryParamsShallow} from "../helpers/FilterFunctions";
import {Distances} from "../enums/enums";
import {useTranslation} from "next-i18next";
import {CustomTFunction, TranslationsKeys} from "../TranslationTypes";

interface VerkaufMobileFilterMenuInterface {
	open: boolean;
	onClose: () => void;
}

export default function VerkaufMobileFilterMenu(
	props: VerkaufMobileFilterMenuInterface
) {
	const router = useRouter();
	const {t} = useTranslation() as unknown as {
		t: CustomTFunction<TranslationsKeys>;
	};
	const bathroomQueryValue = router.query[Filter.BathroomsTotal.queryKey] ?? [
		FilterAnyLabels.BELIEBIG
	];
	const [bathroomSelectedItems, setBathroomSelectedItems] = useState<string[]>(
		enforceArray(bathroomQueryValue)
	);
	const bedroomQueryValue = router.query[Filter.BedroomsTotal.queryKey] ?? [
		FilterAnyLabels.BELIEBIG
	];
	const [bedroomSelectedItems, setBedroomSelectedItems] = useState<string[]>(
		enforceArray(
			Filter.BedroomsTotal.values?.find((val) => {
				if (
					t(val).includes(enforceArray(bedroomQueryValue)[0]) ||
					val === enforceArray(bedroomQueryValue)[0]
				) {
					return val;
				}
			})
		) ?? enforceArray(bedroomQueryValue)
	);

	const livingAreaQueryValue = router.query[Filter.LivingArea.queryKey] ?? [
		FilterAnyLabels.BELIEBIG
	];
	const [livingAreaSelectedItems, setLivingAreaSelectedItems] = useState<
		string[]
	>(
		enforceArray(
			Filter.LivingArea.values?.find((val) => {
				if (
					t(val).includes(enforceArray(livingAreaQueryValue)[0]) ||
					val === enforceArray(livingAreaQueryValue)[0]
				) {
					return val;
				}
			})
		) ?? enforceArray(livingAreaQueryValue)
	);

	const plotSizeQueryValue = router.query[Filter.PlotSize.queryKey] ?? [
		FilterAnyLabels.BELIEBIG
	];
	const [plotSizeSelectedItems, setPlotSizeSelectedItems] = useState<string[]>(
		enforceArray(
			Filter.PlotSize.values?.find((val) => {
				if (
					t(val).includes(enforceArray(plotSizeQueryValue)[0]) ||
					val === enforceArray(plotSizeQueryValue)[0]
				) {
					return val;
				}
			})
		) ?? enforceArray(plotSizeQueryValue)
	);

	const ausstattungQueryLabels = VermietungCategories.Ausstatung.children
		.filter((child) => {
			if (router.query[child.queryKey]) return child;
		})
		.map((child) => child.label);
	const [ausstattungSelectedItems, setAusstattungSelectedItems] = useState<
		string[]
	>(
		enforceArray(ausstattungQueryLabels).length > 0
			? enforceArray(ausstattungQueryLabels)
			: [FilterAnyLabels.BELIEBIG]
	);

	const lageQueryLabels = VermietungCategories.Lage.children
		.filter((child) => {
			if (router.query[child.queryKey]) return child;
		})
		.map((child) => child.label);
	const [lageSelectedItems, setLageSelectedItems] = useState<string[]>(
		enforceArray(lageQueryLabels).length > 0
			? enforceArray(lageQueryLabels)
			: [FilterAnyLabels.BELIEBIG]
	);

	const distanceToSeaQueryValue =
		router.query[Filter.DistanceToSea.queryKey] &&
		enforceArray(router.query[Filter.DistanceToSea.queryKey]).length > 0
			? Object.values(Distances).find(
				(dist) =>
					dist.match_code.toString() ===
					router.query[Filter.DistanceToSea.queryKey]
			)?.label
			: [FilterAnyLabels.BELIEBIG];
	const [distanceToSeaSelectedItems, setDistanceToSeaSelectedItems] = useState<
		string[]
	>(enforceArray(distanceToSeaQueryValue));

	function handleSelectedStates(
		item: string | number,
		checked: boolean,
		selectedItems: string[]
	) {
		let newSelectedItems = selectedItems;
		const stringifiedItem = item.toString();
		if (checked && !newSelectedItems.includes(stringifiedItem)) {
			newSelectedItems.push(stringifiedItem);
			newSelectedItems = newSelectedItems.filter(
				(i) => i !== FilterAnyLabels.BELIEBIG
			);
			newSelectedItems = newSelectedItems.filter(
				(i) => i !== FilterAnyLabels.BELIEBIG
			);
		}
		if (!checked && newSelectedItems.includes(stringifiedItem)) {
			newSelectedItems = newSelectedItems.filter((i) => i !== stringifiedItem);
		}
		if (newSelectedItems.length === 0 || item === FilterAnyLabels.BELIEBIG) {
			newSelectedItems = [FilterAnyLabels.BELIEBIG];
		}
		if (newSelectedItems.length === 0 || item === FilterAnyLabels.BELIEBIG) {
			newSelectedItems = [FilterAnyLabels.BELIEBIG];
		}
		return newSelectedItems;
	}

	function handleReset() {
		replaceRouterQueryParamsShallow(router);
		setBathroomSelectedItems([FilterAnyLabels.BELIEBIG]);
		setBedroomSelectedItems([FilterAnyLabels.BELIEBIG]);
		setPlotSizeSelectedItems([FilterAnyLabels.BELIEBIG]);
		setLivingAreaSelectedItems([FilterAnyLabels.BELIEBIG]);
		setAusstattungSelectedItems([FilterAnyLabels.BELIEBIG]);
		setDistanceToSeaSelectedItems([FilterAnyLabels.BELIEBIG]);
	}

	return (
		<MobileFilterMenu
			items={{
				// bathrooms: {
				//   selected: bathroomSelectedItems,
				//   label: t(Filter.BathroomsTotal.label),
				//   menu: (
				//     <Checklist
				//       mobileVersion
				//       items={
				//         BadezimmerItems(router).items?.map((i) => {
				//           return {
				//             id: i,
				//             primaryLabel: i,
				//             checked: bathroomSelectedItems.includes(i) ? true : false
				//           };
				//         }) ?? []
				//       }
				//       onChange={(item, checked) => {
				//         setBathroomSelectedItems(
				//           handleSelectedStates(item, checked, bathroomSelectedItems)
				//         );
				//         handleDropdownSelect(
				//           BadezimmerItems(router).title,
				//           handleSelectedStates(
				//             item,
				//             checked,
				//             bathroomSelectedItems
				//           ).map((i) => ({ name: i })),
				//           router,
				//           t
				//         );
				//       }}
				//     />
				//   )
				// },
				bedrooms: {
					selected: bedroomSelectedItems,
					label: t(Filter.BedroomsTotal.label),
					menu: (
						<RadioGroupList
							mobileVersion
							items={SchlafzimmerItems(router).items ?? []}
							onChange={(item) => {
								setBedroomSelectedItems(enforceArray(item));
								handleDropdownSelect(
									SchlafzimmerItems(router).title,
									enforceArray({
										name: item
									}),
									router,
									t
								);
							}}
							defaultChecked={bedroomSelectedItems[0]}
						/>
					)
				},
				ausstattung: {
					selected: ausstattungSelectedItems,
					label: t(VermietungCategories.Ausstatung.label),
					menu: (
						<Checklist
							mobileVersion
							items={VerkaufAusstattungItems(router).items}
							onChange={(item, checked) => {
								handleChecklistFilterChange(item, checked, router);
								setAusstattungSelectedItems(
									handleSelectedStates(item, checked, ausstattungSelectedItems)
								);
							}}
						/>
					)
				},
				lage: {
					selected: lageSelectedItems,
					label: t(VermietungCategories.Lage.label),
					menu: (
						<Checklist
							mobileVersion
							items={VerkaufLageItems(router).items}
							onChange={(item, checked) => {
								handleChecklistFilterChange(item, checked, router);
								setLageSelectedItems(
									handleSelectedStates(item, checked, lageSelectedItems)
								);
							}}
						/>
					)
				},
				livingArea: {
					selected: livingAreaSelectedItems,
					label: t(Filter.LivingArea.label),
					menu: (
						<RadioGroupList
							items={LivingAreaItems(router).items ?? []}
							defaultChecked={livingAreaSelectedItems[0]}
							onChange={(item) => {
								handleDropdownSelect(
									LivingAreaItems(router).title,
									enforceArray({name: item}),
									router,
									t
								);
								setLivingAreaSelectedItems(enforceArray(item));
							}}
						/>
					)
				},

				plotSize: {
					selected: plotSizeSelectedItems,
					label: t(Filter.PlotSize.label),
					menu: (
						<RadioGroupList
							items={PlotSizeItems(router).items ?? []}
							defaultChecked={plotSizeSelectedItems[0]}
							onChange={(item) => {
								handleDropdownSelect(
									PlotSizeItems(router).title,
									enforceArray({name: item}),
									router,
									t
								);
								setPlotSizeSelectedItems(enforceArray(item));
							}}
						/>
					)
				}
				// distanceToSea: {
				//   selected: distanceToSeaSelectedItems,
				//   label: t(Filter.DistanceToSea.label),
				//   menu: (
				//     <RadioGroupList
				//       defaultChecked={enforceArray(
				//         DistanceToItems(router, Filter.DistanceToSea).defaultChecked
				//       ).pop()}
				//       mobileVersion
				//       items={DistanceToItems(router, Filter.DistanceToSea).items ?? []}
				//       onChange={(item) => {
				//         handleDropdownSelect(
				//           Filter.DistanceToSea.label,
				//           [{ name: item }],
				//           router,
				//           t
				//         );
				//         setDistanceToSeaSelectedItems([item]);
				//       }}
				//     />
				//   )
				// }
			}}
			open={props.open}
			onClose={props.onClose}
			onSearchChange={(v) => handleSearchChange(v, router)}
			onResetFilter={handleReset}
		/>
	);
}
